import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns.tsx';
import {
	extractDecimalPrecisionFromUnitDenominator,
	formatNumber,
	numberToCompact,
} from '@dealstack/shared/lib/format/number';

export const summarizeOrFormatCost = (cost: number, showSummarized: boolean) => {
	if (!cost || isNaN(cost) || cost === 0) {
		return LONG_DASH;
	}
	return showSummarized
		? numberToCompact(cost)
		: formatNumber({ value: cost, lockPrecision: true });
};

/** Units (or votes) at the security's own decimal precision, so a column keeps fixed decimals. */
export const summarizeOrFormatUnits = (
	units: number,
	unitDenominator: number | null | undefined,
	showSummarized: boolean
) => {
	if (!units || isNaN(units)) {
		return LONG_DASH;
	}

	if (showSummarized) {
		return numberToCompact(units);
	}

	const precision = extractDecimalPrecisionFromUnitDenominator(unitDenominator);

	return formatNumber({
		value: units,
		lockPrecision: precision !== 0,
		minPrecision: precision,
	});
};
